// Copyright 2019 Sorama B.V.

import { IWorkflowModalConfig } from "catalogs/WorkflowModalCatalog";
import {
    IWorkflowModuleInstance,
    IWorkflowModuleModalCreator,
    IWorkflowModuleModalInstance,
} from "../Interfaces/IWorkflowModule";

export class WorkflowModuleModalCreator<T, Y> implements IWorkflowModuleModalCreator<T, Y> {
    public closeCallbacks: ((returnState: Y) => void)[] = [];
    public cancelCallbacks: (() => void)[] = [];
    public showCallbacks: (() => void)[] = [];
    public state: T;

    public lockModuleWhenOpen = false;

    public showCompleted: (
        value?: IWorkflowModuleModalInstance<T, Y> | PromiseLike<IWorkflowModuleModalInstance<T, Y>>
    ) => void;
    public modalCallbacks: { [callbackName: string]: (...args: unknown[]) => void };

    constructor(
        public modalConfig: IWorkflowModalConfig,
        public parentModule: IWorkflowModuleInstance,
        private showCallback: (modal: IWorkflowModuleModalCreator<T, Y>) => void
    ) {}

    //#region IWorkflowModuleModal
    public whenClosed(callback: (returnState: Y) => void): IWorkflowModuleModalCreator<T, Y> {
        this.closeCallbacks.push(callback);
        return this;
    }

    public whenCanceled(callback: () => void): IWorkflowModuleModalCreator<T, Y> {
        this.cancelCallbacks.push(callback);
        return this;
    }

    public whenShowed(callback: () => void): IWorkflowModuleModalCreator<T, Y> {
        this.showCallbacks.push(callback);
        return this;
    }

    public withState(modalState: T): IWorkflowModuleModalCreator<T, Y> {
        this.state = modalState;
        return this;
    }

    public lockModule(): IWorkflowModuleModalCreator<T, Y> {
        this.lockModuleWhenOpen = true;
        return this;
    }

    public show(): Promise<IWorkflowModuleModalInstance<T, Y>> {
        this.showCallback(this);
        return new Promise<IWorkflowModuleModalInstance<T, Y>>((resolve, reject) => {
            this.showCompleted = resolve;
        }).then((x) => {
            for (const callback of this.showCallbacks) {
                callback();
            }
            return x;
        });
    }

    public dispose() {
        this.closeCallbacks = undefined;
        this.showCallbacks = undefined;
        this.cancelCallbacks = undefined;
    }

    public withCallback(
        callbackName: string,
        callback: (...args: unknown[]) => void
    ): IWorkflowModuleModalCreator<T, Y> {
        this.modalCallbacks[callbackName] = callback;
        return this;
    }
}
